import React, { memo, SVGProps } from 'react'

export const Message = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M20.7227 5.5348L20.6632 5.6044L20.719 5.53114L20.7004 5.51648C20.2988 5.18315 19.7893 5 19.2649 5H4.73136C4.20699 5 3.69749 5.18315 3.29957 5.51282C3.29213 5.52015 3.28469 5.52747 3.26982 5.53846C2.78264 5.95971 2.5 6.5641 2.5 7.1978V16.8022C2.5 18.0147 3.50039 19 4.73136 19H19.2686C20.4996 19 21.5 18.0147 21.5 16.8022V7.1978C21.5 6.56044 21.2174 5.95604 20.7227 5.5348ZM18.6736 6.4652L11.9981 12.1319L5.32638 6.4652H18.6773H18.6736ZM20.0124 16.8022C20.0124 17.2051 19.6777 17.5348 19.2686 17.5348H4.73136C4.32227 17.5348 3.98757 17.2051 3.98757 16.8022V7.26374L11.5147 13.6557C11.7824 13.8828 12.2176 13.8828 12.4853 13.6557L20.0124 7.26374V16.8022Z"
      fill="currentColor"
    />
  </svg>
))
